import { Component, QueryList, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { FOCRequestService } from '../foc-requests.service';
import { ErrorHandler } from '../../shared/services/error-handler.service'
import { HttpService } from '../../shared/services/http.service'
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialog, MdDialogRef, MdAutocompleteTrigger, MdAutocomplete } from '@angular/material';
import { dialogComponent } from '../../dialog/dialog.component';
import { FileUploader } from 'ng2-file-upload';
import * as $ from 'jquery';
import { addNewAddressComponent } from '../../trade/details/addNewAddress.component';
import { addNewContactComponent } from '../../trade/details/addNewContact.component';
import { countries } from '../../shared/coutry-data-store';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { Console } from 'console';
import match from 'core-js/fn/symbol/match';
import { TranslateService } from 'ng2-translate';


@Component({
    selector: 'request-add',
    template: require('./foc-request_add.component.html'),
    styles: [require('./foc-request_add.component.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler, FOCRequestService]
})

export class FOCRequestAddComponent {

    requestCreateForm: FormGroup;
    dialogRef;
    request: any;
    name: any;
    addressList: any;
    contactList: any;
    tradeData: any = {};
    billingData: any = {};
    selectedAddress: any;
    selectedCountry: String = '';
    countryFromID: String = '';
    selectedContactName: any;
    selectedContactEmail: any;
    selectedContactPhone: any;
    palletDisable: boolean = true;
    requestFormData: any = {};
    userData: any;
    requestOrder: any;
    parcels: any;
    id: any;
    selectedParcel: any;
    isAdmin: boolean = false;
    isOTD: boolean = false;
    isEndConsumner: boolean = false;
    tradePartnerId: String = '';
    istradePartnerId: boolean = false;
    createdBy: any;
    isResponsible: boolean = false;
    responsibleError: any;
    isIcb: boolean = false;
    returnUploadFiles: any;
    uploader;
    fileUploadResponse: any;
    isFileUploaded: boolean = false;
    isFileUploadError: boolean = false;
    URL: any = APPCONFIG.appUrlBase + '/uploadFiles';
    fileUrl: any = [];
    soldTo: any;
    enableButtons: boolean = false;
    isShippingCountry: boolean = true;
    addressSub:Subscription;
    isD2CUser:boolean=false;
    isTempContact:boolean = false;
    isExistingContactSelected:boolean = false;
    isContactModified: boolean = false;
    saving: boolean = false;
    private _contactJustSaved: boolean = false;

   private isFreshStart: boolean = false;

// ADD HERE
isFOC_Admin: boolean = false;
isFOC_Approver: boolean = false;
isFOC_HR: boolean = false;
isFOC_Employee: boolean = false;
isFocOrder: boolean = false;

private _lastTradeIdLoaded: string = null;
private _tradeReqInFlight: boolean = false;

   

    soldToList: any[] = [];
soldToControl: FormControl = new FormControl();
filteredSoldToList: Observable<any[]>;
selectedSoldToId: any = null;
focRole: string = null;


filteredContacts: Observable<any[]>;

contactControl: FormControl = new FormControl('', Validators.required);

emailControl: FormControl = new FormControl(
  '',
  [Validators.required, Validators.email]
);

phoneControl: FormControl = new FormControl('', Validators.required);


filteredEmails: Observable<any[]>;
filteredPhones: Observable<any[]>;
filteredAddressList: Observable<any[]>;


// NEW: map ID -> definition text
soldToDefinitionMap: { [id: string]: string } = {};
@ViewChildren(MdAutocompleteTrigger) private _triggers: QueryList<MdAutocompleteTrigger>;

    public countries: any = countries;
    constructor(private router: Router, private route: ActivatedRoute,private translate: TranslateService, private http: HttpService, private formBuilder: FormBuilder, private commonService: CommonService,
        private sessionHandler: SessionHandler, private dialog: MdDialog, private Http: Http,private sanitizer: DomSanitizer) {
        this.tradeData = {};
        this.requestOrder = {};

        const qp = (this.route.snapshot.queryParams && this.route.snapshot.queryParams['fresh']) || null;
        this.isFreshStart = (qp === '1');

        if (this.isFreshStart) {
            // hard reset cached draft before any restore code runs
       this.commonService.setData(null);

        const urlTree = this.router.createUrlTree([], {
            relativeTo: this.route,
            queryParams: {},
            queryParamsHandling: '' // remove all query params
        });
        this.router.navigateByUrl(urlTree, { replaceUrl: true });

        }

        if (this.http.checkSession()) {
            this.parcels = ["0", "1", "2", "3", "4", "5", "6", "7", "8"];
            this.selectedParcel = "0";
            this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));

            var roles: string[] = [];
            if (this.userData && this.userData.role && this.userData.role.length > 0) {
                roles = this.userData.role;
            }

            // DO NOT USE includes() → breaks in your TS version
            this.isFOC_Admin     = roles.indexOf('FOC_ADMINISTRATOR') !== -1;
            this.isFOC_Approver  = roles.indexOf('FOC_APPROVER') !== -1;
            this.isFOC_HR        = roles.indexOf('FOC_HR') !== -1;
            this.isFOC_Employee  = roles.indexOf('FOC_EMPLOYEE') !== -1;

            // ANY FOC role = this is a FOC order
            this.isFocOrder =
                this.isFOC_Admin ||
                this.isFOC_Approver ||
                this.isFOC_HR ||
                this.isFOC_Employee;

                if (this.isFOC_Admin) {
                    this.focRole = 'FOC_ADMINISTRATOR';
                } else if (this.isFOC_Approver) {
                    this.focRole = 'FOC_APPROVER';
                } else if (this.isFOC_HR) {
                    this.focRole = 'FOC_HR';
                } else if (this.isFOC_Employee) {
                    this.focRole = 'FOC_EMPLOYEE';
                }

            let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
            if (icbCheck) {
                this.isIcb = true;
            } else {
                this.isIcb = false;
            }
            this.route.params.subscribe(params => {
                this.id = +params['id'];
            });
            let data = this.commonService.getData();
            if (this.userData) {
                if (this.userData.role && this.userData.role.length > 0) {
                    if (this.userData.role.includes('ADMIN')) {
                        this.isAdmin = true;
                    }
                    if (this.userData.role.includes('OTD_APPROVER')) {
                        this.isOTD = true;
                    } if (this.userData.role.includes('END_CONSUMER')) {
                        this.isEndConsumner = true;
                    }
                    // ***Old***
                    // for (let u in this.userData.role) {
                    //     if (this.userData.role[u] == 'ADMIN') {
                    //         this.isAdmin = true;
                    //     }
                    //     if (this.userData.role[u] == 'OTD_APPROVER') {
                    //         this.isOTD = true;
                    //     }if (this.userData.role[u] == 'END_CONSUMER') {
                    //         this.isEndConsumner = true;                    
                    //     }
                    // }
                }
                if (data && data['requestOrder']) {
                    this.requestFormData = data;
                    this.requestOrder = data['requestOrder'];
                    this.commonService.changeViewData(data);
                } else {
                    this.requestFormData['returnOrder'] = {};
                }
                let saved = this.commonService.getData();

                if (!saved && !this.isAdmin && !this.isOTD && !this.isEndConsumner && !this.isFocOrder) {
                    // this.getTradeData();
                }
                
                if (!saved && this.isFocOrder) {
                    // this.getTradeData();
                }
                
                if (this.isAdmin && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    // this.getTradeData();
                }
                if (this.isOTD && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    // this.getTradeData();
                }
                if (this.isEndConsumner && this.requestFormData.tradeId && this.requestFormData.tradeId != null) {
                    this.tradePartnerId = this.requestFormData.tradeId;
                    // this.getTradeData();
                }
                if (this.isOTD && this.requestFormData.createdBy && this.requestFormData.createdBy != null) {
                    this.createdBy = this.requestFormData.createdBy;
                } else if (this.isEndConsumner && this.requestFormData.createdBy && this.requestFormData.createdBy != null) {
                    this.createdBy = this.requestFormData.createdBy;
                }
                else {
                    if ((!this.isOTD && !this.isEndConsumner) && this.userData.userName)
                        this.createdBy = this.userData.userName;
                }
            }
            this.commonService.addressChange.subscribe(() => {
                this.getAddressList();
            });
            this.commonService.contactChange.subscribe(() => {
              console.log('contactChange received');
                this.getContactList();
            });
        } else {
            this.http.showSessionError();
        }
        console.log("RESTORED DATA:", this.commonService.getData());

    }

    ngOnDestroy(){
        if(this.addressSub)
        this.addressSub.unsubscribe();     //clear subscription for address change
    }

  ngOnInit() {
    this.buildForm();
    this.getSoldToList();
    const saved = this.commonService.getData();

    if (saved && saved.requestOrder && saved.requestOrder.soldToId) {

      // Always restore from soldToId (Option 1)
      const restoredId = String(saved.requestOrder.soldToId).replace(/^0+/, '');

      this.tradePartnerId = restoredId;
      this.selectedSoldToId = restoredId;

      // Set UI value without emitting events
      this.soldToControl.setValue(restoredId, { emitEvent: false });

      // Load trade data exactly as user saw before
      this.getTradeData(restoredId);
    }
    this.contactControl.valueChanges
      .debounceTime(300)
      .subscribe(() => this.persistDraft());

    this.emailControl.valueChanges
      .debounceTime(300)
      .subscribe(() => this.persistDraft());

    this.phoneControl.valueChanges
      .debounceTime(300)
      .subscribe(() => this.persistDraft());
    // ensure the control triggers getTradeData when user types full ID or presses enter/blur
    this.soldToControl.valueChanges
      .pipe(debounceTime(100))
      .subscribe((val: any) => {
        // if value is exactly a soldTo string (user typed full ID or selected), call handler
        if (typeof val === 'string' && this.soldToList && this.soldToList.indexOf(val) !== -1) {
          this.soldToOptionSelected(val);
          return;
        }
        // if value is an object (autocomplete sometimes returns an object), handle its string form
        if (val && typeof val === 'object') {
          const idOrDisplay = (val as any).id || (val as any).display;
          if (idOrDisplay) {
            const v = String(idOrDisplay);
            if (this.soldToList.indexOf(v) !== -1) {
              this.soldToOptionSelected(v);
            }
          }
        }
      });
    this.addressSub = this.commonService.addressSourceObs.subscribe(res => {
      if (
        res &&
        this.requestCreateForm &&
        this.requestCreateForm.get('pickupSame') &&
        this.requestCreateForm.get('pickupSame').value === 'false'
      ) {
        this.selectedAddress = res;
        this.requestCreateForm
          .get('pickupAddressId')
          .setValue(res, false);
      }
    });
    const pickupCtrl = this.requestCreateForm.get('pickupAddressId') as FormControl;
    this.filteredAddressList = pickupCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterAddressList(value))
    );

    this.filteredContacts = this.contactControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterContacts(value))
    );

    this.filteredEmails = this.emailControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterEmails(value))
    );

    this.filteredPhones = this.phoneControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterPhones(value))
    );

    
this.contactControl.valueChanges.subscribe(val => {
  
const hasNameId = !!this.requestCreateForm.get('contactNameId').value;

  if (hasNameId) return;

  // ✅ If no nameId, ALWAYS temp
  this.isTempContact = true;

});


    pickupCtrl.valueChanges.subscribe(val => {
      const list = this._filterAddressList(val) || [];
      const asString = this._asText(val, 'address'); // normalize typed string
      // Only flag when user typed something and there are no matches
      if (asString && list.length === 0) {
        pickupCtrl.setErrors({ ...(pickupCtrl.errors || {}), noMatch: true });
      } else {
        // Remove only the noMatch error, keep others (if any)
        const errs = { ...(pickupCtrl.errors || {}) };
        if ('noMatch' in errs) delete errs['noMatch'];
        pickupCtrl.setErrors(Object.keys(errs).length ? errs : null);
      }
    });

    this.emailControl.valueChanges.subscribe(val => {
      const hasNameId = !!this.requestCreateForm.get('contactNameId').value;
      if (hasNameId) return;
      this.isTempContact = true;
    });

    this.phoneControl.valueChanges.subscribe(val => {
      const hasNameId = !!this.requestCreateForm.get('contactNameId').value;
      if (hasNameId) return;
      this.isTempContact = true;
    });
    
 const detectContactEdit = () => {
  if (!this.isExistingContactSelected || !this._originalContact) {
    return;
  }

  const name  = this._asText(this.contactControl.value, 'name');
  const email = this._asText(this.emailControl.value, 'email');
  const phone = this._asText(this.phoneControl.value, 'phone');

  const modified =
    name  !== this._originalContact.name ||
    email !== this._originalContact.email ||
    phone !== this._originalContact.phone;

  this.isContactModified = modified;
  
    this.isTempContact = false;

};

  this.contactControl.valueChanges.subscribe(detectContactEdit);
  this.emailControl.valueChanges.subscribe(detectContactEdit);
  this.phoneControl.valueChanges.subscribe(detectContactEdit);

  /* ---------------- rest of ngOnInit ---------------- */

    var instrCtrl = this.requestCreateForm.get('instructions');
    if (instrCtrl && instrCtrl.valueChanges && instrCtrl.valueChanges.pipe) {
      instrCtrl.valueChanges
        .pipe(debounceTime(200))
        .subscribe(() => this.persistDraft());
    }



  }

private _asText(
  val: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): string {
  if (val == null) return '';

  if (typeof val === 'string') return val.trim();

  if (typeof val === 'object') {
    if (kind === 'name')    return (val.contactName || '').trim();
    if (kind === 'email')   return (val.contactEmail || '').trim();
    if (kind === 'phone')   return (val.contactPhone || '').trim();
    if (kind === 'address') return (val.address || '').trim();

    // ✅ sold-to / trade partner
    if (kind === 'soldTo') {
      return (
        val.soldTo ||
        val.tradePartnerId ||
        val.id ||
        ''
      ).toString().trim();
    }
  }

  return String(val || '').trim();
}

private _triggerFor(ac: MdAutocomplete): MdAutocompleteTrigger | undefined {
  if (!this._triggers) return undefined;
  const list = this._triggers.toArray();          // QueryList → Array
  return list.find(t => t.autocomplete === ac);   // now safe
}


  openPanelFor(ac: MdAutocomplete, sourceList: any[]) {
  if (!sourceList || sourceList.length === 0) return;

  // 🔁 Make sure all filters emit at least once when inputs are empty.
  if (this.contactControl.value == null || this.contactControl.value === '') {
    this.contactControl.setValue('', { emitEvent: true });
  }
  if (this.emailControl.value == null || this.emailControl.value === '') {
    this.emailControl.setValue('', { emitEvent: true });
  }
  if (this.phoneControl.value == null || this.phoneControl.value === '') {
    this.phoneControl.setValue('', { emitEvent: true });
  }

  const trig = this._triggerFor(ac);
  if (trig) {
    setTimeout(() => trig.openPanel());
  }
}

// Map autocomplete -> its FormControl (adjust if you renamed template refs)
  private _controlFor(ac: MdAutocomplete): FormControl | null {
    // If you passed the template refs from HTML, identity comparison works:
    if ((ac as any).panel && this.contactControl) return this.contactControl; // fallback default
    return null; // optional; you can also skip this and just force all three controls to emit in saveContactList
  }
  private _filterAddressList(value: any): any[] {

        if (!this.addressList) return [];
      
        let search = '';
      
        // when typing
        if (typeof value === 'string') {
          search = value.toLowerCase();
        }
        // when object selected
        else if (value && value.address) {
          search = value.address.toLowerCase();
        }
      
        if (!search) {
          return this.addressList.slice();
        }
      
        return this.addressList.filter(c =>
          c.address &&
          c.address.toLowerCase().includes(search)
        );
      }

    private _filterContacts(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        // when typing
        if (typeof value === 'string') {
          search = value.toLowerCase();
        }
        // when object selected
        else if (value && value.contactName) {
          search = value.contactName.toLowerCase();
        }
      
        if (!search) {
          return this.contactList.slice();
        }
      
        return this.contactList.filter(c =>
          c.contactName &&
          c.contactName.toLowerCase().includes(search)
        );
      }

      private _filterEmails(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        if (typeof value === 'string') {
          search = value.toLowerCase();
        } else if (value && value.contactEmail) {
          search = value.contactEmail.toLowerCase();
        }
      
        if (!search) return this.contactList.slice();
      
        return this.contactList.filter(c =>
          (c.contactEmail || '').toLowerCase().includes(search)
        );
      }

      private _filterPhones(value: any): any[] {

        if (!this.contactList) return [];
      
        let search = '';
      
        if (typeof value === 'string') {
          search = value;
        } else if (value && value.contactPhone) {
          search = value.contactPhone;
        }
      
        if (!search) return this.contactList.slice();
      
        return this.contactList.filter(c =>
          (c.contactPhone || '').includes(search)
        );
      }
      displayAddress = (address: any): string => {
        return address && address.address
          ? address.address
          : '';
      };
     
displayContact = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactName ? value.contactName : '');

displayEmail = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactEmail ? value.contactEmail : '');

displayPhone = (value: any): string =>
  typeof value === 'string' ? value : (value && value.contactPhone ? value.contactPhone : '');


get isTradePartnerSelected(): boolean {
  return !!this.tradePartnerId;
}

get isContactFormValid(): boolean {
  return (
    this.contactControl.valid &&
    this.emailControl.valid &&
    this.phoneControl.valid &&
    this.isTradePartnerSelected
  );
}


// NAME selected → set all three to same id
onAddressSelected(event: any, address: any) {
  // ignore deselection
  if (!event || !event.source || !event.source.selected) return;

  const id = address && address.id;

  // set all three ids to same id
  this.requestCreateForm.patchValue({
    pickupAddressId: id,
  }, { emitEvent: false });

  // set all three controls to same contact object
  const pickupCtrl = this.requestCreateForm.get('pickupAddressId') as FormControl;
  pickupCtrl.setValue(address, { emitEvent: false });

  this.persistDraft();
}

private _originalContact: any = null;

onContactSelected(event: any,contact: any) {

  if (!event || !event.source || !event.source.selected) {
    return; // 🔒 ignore deselect / hover
  }

  // ignore deselection
 if(!contact) return;

  const id = contact && contact.id;


this.isExistingContactSelected = true;
  this.isTempContact = false;
this.isContactModified = false;

  // ✅ store original values
  this._originalContact = {
    name: contact.contactName,
    email: contact.contactEmail,
    phone: contact.contactPhone
  };


  // set all three ids to same id
  this.requestCreateForm.patchValue({
    contactNameId: id,
    contactEmailId: id,
    contactPhoneId: id
  }, { emitEvent: false });

  // set all three controls to same contact object
  this.contactControl.setValue(contact.contactName, { emitEvent: false });
  this.emailControl.setValue(contact.contactEmail, { emitEvent: false });
  this.phoneControl.setValue(contact.contactPhone, { emitEvent: false });

this.contactControl.updateValueAndValidity();
  this.emailControl.updateValueAndValidity();
  this.phoneControl.updateValueAndValidity();

  // persist draft if you’re caching between steps
  if (this.requestFormData) {
    this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
    this.commonService.setData(this.requestFormData);
  }
}

emailSelected(event: any, contact: any) {
  if (!event || !event.source || !event.source.selected) return;
  if (!contact) return;

  // ✅ Name selection decides identity, not email
  const hasNameId = !!this.requestCreateForm.get('contactNameId').value;

  console.log("nameid",hasNameId);

  if (!hasNameId) {
    // ❌ name is NOT from existing contact → fresh contact
    this.isExistingContactSelected = false;
    this.isTempContact = true;
    this.isContactModified = false;
    this._originalContact = null;

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });
  }
  // ✅ else: keep existing contact context

  this.emailControl.setValue(contact.contactEmail, { emitEvent: false });
  this.emailControl.updateValueAndValidity();

  this.persistDraft();
}

phoneSelected(event: any, contact: any) {
  if (!event || !event.source || !event.source.selected) return;
  if (!contact) return;

  const hasNameId = !!this.requestCreateForm.get('contactNameId').value;

  if (!hasNameId) {
    this.isExistingContactSelected = false;
    this.isTempContact = true;
    this.isContactModified = false;
    this._originalContact = null;

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });
  }

  this.phoneControl.setValue(contact.contactPhone, { emitEvent: false });
  this.phoneControl.updateValueAndValidity();

  this.persistDraft();
}


    public getSoldToList() {
        const roleQuery = this.focRole ? `?role=${this.focRole}` : '';

        this.http.getRequest('focApi/v1/getFOCSoldToList' + roleQuery)
          .subscribe(
            (res: any) => {
              try {
                if (res && Array.isArray(res.soldToList)) {
                  this.soldToDefinitionMap = {};
                  const uniqueIds: { [k: string]: boolean } = {};
                  const ids: string[] = [];
      
                  res.soldToList.forEach((item: any) => {
                    if (!item || !item.soldTo) { return; }
                    const id = String(item.soldTo);
      
                    // keep first occurrence of each soldTo
                    if (!uniqueIds[id]) {
                      uniqueIds[id] = true;
                      ids.push(id);
                    }
      
                    // save definition (or empty string)
                    this.soldToDefinitionMap[id] = item.soldToDefinition || '';
                  });
      
                  this.soldToList = ids;   // <-- pure string IDs
                } else if (Array.isArray(res)) {
                  // fallback if API ever returns just an array of strings
                  this.soldToDefinitionMap = {};
                  this.soldToList = res.map((s: any) => String(s));
                } else {
                  this.soldToDefinitionMap = {};
                  this.soldToList = [];
                }
      
                this.setupSoldToFilter();
              } catch (e) {
                console.error('getSoldToList parse error', e);
              } finally {
                this.http.onEnd && this.http.onEnd();
              }
            },
            (err) => {
              console.error('getSoldToList error', err);
              this.http.onEnd && this.http.onEnd();
            }
          );
      }
      
      
      
      
      private setupSoldToFilter() {
        this.filteredSoldToList = this.soldToControl.valueChanges.pipe(
          startWith(''),
          debounceTime(150),
          map(value => this._filterSoldTo(value))
        );
      }
    
      displaySoldTo = (value: string): string => {
        if (!value) return '';
        const def = this.soldToDefinitionMap[value];
        return def ? `${value} - ${def}` : value;
      };
      
      
      private _filterSoldTo(value: any): any[] {
        if (!this.soldToList || this.soldToList.length === 0) return [];
      
        let term = '';
      
        if (!value) {
          term = '';
        } else if (typeof value === 'string') {
          term = value.toLowerCase();
        } else {
          term = String(value).toLowerCase();
        }
      
        // If input is empty, show full list
        if (term === '') return this.soldToList.slice();
      
        return this.soldToList.filter(id => {
          const idStr = String(id).toLowerCase();
          const defStr = (this.soldToDefinitionMap[id] || '').toLowerCase();
      
          // match on soldTo OR soldToDefinition
          return idStr.includes(term) || defStr.includes(term);
        });
      }
      

      
      
      /** called by (optionSelected) with the selected value (string) */
      public soldToOptionSelected(selectedValue: any) {
        // normalize: if called with an autocomplete event ({ option: { value: ... } })
        const incoming = (selectedValue && selectedValue.option && selectedValue.option.value) ? selectedValue.option.value : selectedValue;
      
        if (!incoming) {
          if (this.requestCreateForm && this.requestCreateForm.controls['soldToId']) {
            this.requestCreateForm.controls['soldToId'].setValue(null);
          }
          this.selectedSoldToId = null;
          this.tradePartnerId = null;
          this.istradePartnerId = false;
          return;
        }
      
        const id = String(incoming);
        this.selectedSoldToId = id;
      
        if (this.requestCreateForm && this.requestCreateForm.controls['soldToId']) {
          this.requestCreateForm.controls['soldToId'].setValue(id);
        }
      
        this.tradePartnerId = id;
        this.istradePartnerId = true;
      
        this.getTradeData(id);
      }
      
  
      
      public onSoldToBlur(): void {
        try {
          const val = this.soldToControl && this.soldToControl.value;
          // nothing typed
          if (!val) {
            if (this.requestCreateForm && this.requestCreateForm.controls['soldToId']) {
              this.requestCreateForm.controls['soldToId'].setValue(null);
            }
            return;
          }
      
          // If user typed a string, try to resolve to first candidate
          if (typeof val === 'string') {
            const candidates = this._filterSoldTo(val);
            if (candidates && candidates.length > 0) {
              const first = candidates[0];
              // if soldToList items are objects use first.id, else use first (string)
              this.soldToControl.setValue(first);
              // call selection handler in same shape as autocomplete event
              this.soldToOptionSelected({ option: { value: first } });
              return;
            } else {
              // no match -> clear soldToId
              if (this.requestCreateForm && this.requestCreateForm.controls['soldToId']) {
                this.requestCreateForm.controls['soldToId'].setValue(null);
              }
              return;
            }
          }
      
          // If value is already an object or primitive selected from list
          // Normalize to the stored value shape (string or object)
          const normalized = (typeof val === 'object' && val !== null) ? val : String(val);
          this.soldToOptionSelected({ option: { value: normalized } });
      
        } catch (err) {
          console.error('onSoldToBlur error', err);
        }
      }

    public scrollTo() {
        $('html, body').animate({
            scrollTop: $("#createdBy").offset().top
        }, 1000);
    }

    public getRequestDataWithId() {

        this.http.getRequest('returnOrder/v1/getReturnOrder?orderId=' + this.id)
            .subscribe(
                res => { this.saveRequestData(res) },
                err => {
                    // Log errors if any
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                });
    }

    public tradePartnerIdEmptyheck() {
        // this.resetData();
        if (this.tradePartnerId != null && this.tradePartnerId != '') {
            this.istradePartnerId = true;
        }
    }

    public responsibleEmptyheck() {
        if (this.createdBy != null && this.createdBy != '') {
            this.isResponsible = true;
        }
    }

    public getTradeData(id?: string) {

        const tradeId = (id || this.tradePartnerId || '').trim();
        if (!tradeId) return;
    

      // ✅ Dedupe: skip if same id already loaded or currently loading
      if (this._tradeReqInFlight && this._lastTradeIdLoaded === tradeId) {
        return;
      }
      if (this._lastTradeIdLoaded === tradeId) {
        return;
      }

        // UK restriction
        if (tradeId === '50032940' || tradeId.includes('50032940')) {
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg =
            'Currently this service is not available for Uk. Please contact admin for further information.';
          return;
        }
        this._tradeReqInFlight = true;
        this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId=' + tradeId)
          .subscribe(
            res => {
              this._lastTradeIdLoaded = tradeId;
              this.saveTradeData(res);

            },
            err => {
              this.tradePartnerId = null;
              this.istradePartnerId = false;
              if (err && err.status !== 0) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = err;
              }
              this.http.onEnd();
            }
          ).add(() => {
      this._tradeReqInFlight = false;        // ✅ clear in-flight flag
    });
    }
    
      

    public saveRequestData(res) {
        if (res.responseStatus == 'Success') {
            this.requestFormData = res.returnReqDto;
            this.requestOrder = res.returnReqDto.requestOrder;
            this.commonService.changeViewData(res.returnReqDto);
            this.setDefaultData();
        }
        if (res.responseStatus == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }

    public saveTradeData(res) {
        this.enableButtons = true;
        this.isD2CUser = res.isD2CUser && res.isD2CUser.toLowerCase() == 'true';
    
        if (res.status == "Success" && (res.tradePartner || this.isD2CUser)) {
            this.tradeData = res.tradePartner;
            this.getAddressList();
            this.updateFormValidationForD2C(this.isD2CUser);
        } else {
            this.tradePartnerId = null;
            this.istradePartnerId = false;
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 
              'Trade data not found.To Create new request Please save default trade details first.';
            this.dialogRef.afterClosed().subscribe(result => {
                // this.router.navigateByUrl('/app/trade/details');
                this.dialogRef = null;
            });
            this.http.onEnd();
        }
    }
    
    private getSelectedShippingAddress() {
        if (!this.addressList || !this.requestCreateForm) {
          return null;
        }
      
        const id = this.requestCreateForm.get('pickupAddressId')
          ? this.requestCreateForm.get('pickupAddressId').value
          : null;
      
        if (!id) {
          return null;
        }
      
        return this.addressList.find(
          a => String(a.id) === String(id)
        );
      }
      
      

    public getAddressList() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner || this.isFocOrder) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '' && tradeId != undefined) {
            let data = {};
            data['tradePartnerId'] = tradeId;
            data['salesOrgId'] = APPCONFIG.salesOrgId;
            data['isICBUser'] = this.isIcb;
            this.http.postRequest(data, 'tradePartnerDetails/v1/invoiceBillingAddress')
                .subscribe(
                    res => {
                        this.saveAddressList(res);
                    },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;

                        }
                        this.http.onEnd();
                    });
        }
        this.soldTo = this.tradeData.name1;
        this.requestFormData.soldTo = this.soldTo;
        //console.log('this.soldTo ' + this.soldTo);
    }

  private persistDraft() {
    if (!this.requestFormData) this.requestFormData = {};


    // clone raw form
    const raw = this.requestCreateForm.getRawValue();
     raw.contactName = this._asText(this.contactControl.value, 'name');
      raw.contactEmail = this._asText(this.emailControl.value, 'email');
      raw.contactPhone = this._asText(this.phoneControl.value, 'phone');

    raw.isTempContact =
      !!(
        (raw.contactName || raw.contactEmail || raw.contactPhone) &&
        !(raw.contactNameId || raw.contactEmailId || raw.contactPhoneId)
      );
    ;
    raw.isContactModified = this.isContactModified;

    if (this.isTempContact && !this._contactJustSaved) {
      // ✅ VERY IMPORTANT → save as NEW
      raw.contactNameId = null;
      raw.contactEmailId = null;
      raw.contactPhoneId = null;
    }
    // normalize pickupAddressId to id (in case control currently holds object)
    const v = this.requestCreateForm.get('pickupAddressId') ? this.requestCreateForm.get('pickupAddressId').value : null;
    raw.pickupAddressId = (v && typeof v === 'object') ? v.id : v;

    this.requestFormData['requestOrder'] = raw;

    this.commonService.setData(this.requestFormData);
    console.log('persistDraft overwrite', raw.contactName);
  }


    public getContactList() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner || this.isFocOrder) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '') {
            this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + tradeId)
                .subscribe(
                    res => { this.saveContactList(res) },
                    err => {
                        if (err && err.status != 0) {
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;

                        }
                        this.http.onEnd();
                    });
        }
    }

  public saveAddressList(res) {
    const previouslySelected =
      this.requestCreateForm &&
        this.requestCreateForm.get('pickupAddressId')
        ? this.requestCreateForm.get('pickupAddressId').value
        : null;

    if (res.billingAddress) {
      this.billingData = res.billingAddress;
      if (res.billingAddress && res.billingAddress.id) {
        this.tradePartnerId = res.billingAddress.id;
        if (this.requestCreateForm && this.requestCreateForm.get('soldToId')) {
          this.requestCreateForm
            .get('soldToId')
            .setValue(res.billingAddress.id, false);
        }
      }
    }
    if (res.shippingAddressList.length > 0) {
      this.addressList = res.shippingAddressList;
      this.getContactList();
      this.http.onEnd();
    } else {
      this.dialogRef = this.dialog.open(dialogComponent);
      this.dialogRef.componentInstance.msg = 'To create new request please save address details first.';
      // alert('To create new request please save address details first.');
      this.http.onEnd();
      // this.router.navigateByUrl('/app/trade/details');
    }
    if (
      previouslySelected &&
      this.requestCreateForm &&
      this.requestCreateForm.get('pickupSame') &&
      this.requestCreateForm.get('pickupSame').value === 'false'
    ) {

      const ctrl = this.requestCreateForm.get('pickupAddressId') as FormControl;
      const found = this.addressList && this.addressList.find(a => String(a.id) === String(previouslySelected));

      this.requestCreateForm.patchValue({ pickupAddressId: found ? found.id : null }, { emitEvent: false });
      ctrl.setValue(found || null, { emitEvent: false });

    }

if (
  this.requestCreateForm &&
  this.requestCreateForm.get('pickupSame') &&
  this.requestCreateForm.get('pickupSame').value === 'true'
) {
  this.setDefaultAddress();
}
this.restorePickupAddressFromDraft();
  }

  private restorePickupAddressFromDraft() {
  const saved = this.commonService.getData();
  if (
    !saved ||
    !saved.requestOrder ||
    saved.requestOrder.pickupSame !== 'false' ||
    !saved.requestOrder.pickupAddressId
  ) {
    return;
  }

  const ctrl = this.requestCreateForm.get('pickupAddressId') as FormControl;
  if (!ctrl || !this.addressList) return;

  const found = this.addressList.find(a =>
    String(a.id) === String(saved.requestOrder.pickupAddressId)
  );

  if (!found) return;

  // 🔑 enable → set → optionally disable
  const wasDisabled = ctrl.disabled;
  if (wasDisabled) {
    ctrl.enable({ emitEvent: false });
  }

  // ✅ give autocomplete the OBJECT
  ctrl.setValue(found, { emitEvent: false });


  if (wasDisabled) {
    ctrl.disable({ emitEvent: false });
  }
}


private refreshContactAutocomplete(): void {
  const currentValue = this.contactControl.value;
  this.contactControl.setValue(currentValue, { emitEvent: true });
}

  public saveContactList(res: any) {

  // =========================
  // D2C USERS (unchanged)
  // =========================
  if (this.isD2CUser) {
    if (this.billingData && this.billingData.id) {
      this.requestCreateForm.get('soldToId').setValue(this.billingData.id);
    }
    this.http.onEnd();
    return;
  }

  // =========================
  // SAFE CONTACT LIST
  // =========================
  const items = (res && Array.isArray(res.items)) ? res.items : [];
  this.contactList = items.sort((a, b) =>
    String(a.contactName || '').localeCompare(String(b.contactName || ''))
  );

  // =========================
  // LOAD DRAFT / REQUEST ORDER
  // =========================
  const draft = this.commonService.getData();
  const ro = (draft && draft.requestOrder)
    ? draft.requestOrder
    : (this.requestOrder || {});

  // =========================
  // DATA FACTS (DO NOT TRUST FLAGS)
  // =========================
  const hasIds = !!(
    ro.contactNameId ||
    ro.contactEmailId ||
    ro.contactPhoneId
  );

  const hasValues = !!(
    ro.contactName ||
    ro.contactEmail ||
    ro.contactPhone
  );

  // =========================
  // MATCH EXISTING CONTACTS
  // =========================
  const idName  = ro.contactNameId  != null ? String(ro.contactNameId)  : null;
  const idEmail = ro.contactEmailId != null ? String(ro.contactEmailId) : null;
  const idPhone = ro.contactPhoneId != null ? String(ro.contactPhoneId) : null;

  const foundName  = idName  ? this.contactList.find(c => String(c.id) === idName)  : null;
  const foundEmail = idEmail ? this.contactList.find(c => String(c.id) === idEmail) : null;
  const foundPhone = idPhone ? this.contactList.find(c => String(c.id) === idPhone) : null;

  // =========================
  // RESET UI FLAGS (always)
  // =========================
  this.isExistingContactSelected = false;
  this.isTempContact = false;
  this.isContactModified = false;
  this._originalContact = null;

  // =====================================================
  // ✅ CASE 1: EXISTING CONTACT (IDs present)
  // =====================================================
  if (hasIds && (foundName || foundEmail || foundPhone)) {

    const c = foundName || foundEmail || foundPhone;

    // Populate UI
    this.contactControl.setValue(ro.contactName || '', { emitEvent: false });
    this.emailControl.setValue(ro.contactEmail || '', { emitEvent: false });
    this.phoneControl.setValue(ro.contactPhone || '', { emitEvent: false });

    // Restore form IDs
    this.requestCreateForm.patchValue({
      contactNameId: foundName  ? c.id : null,
      contactEmailId: foundEmail ? c.id : null,
      contactPhoneId: foundPhone ? c.id : null
    }, { emitEvent: false });

    
  this._originalContact = {
    name: c.contactName,
    email: c.contactEmail,
    phone: c.contactPhone
  };

  this.isExistingContactSelected = true;

  // ✅ THIS IS THE MISSING PART
  this.isContactModified =
    ro.contactName  !== c.contactName ||
    ro.contactEmail !== c.contactEmail ||
    ro.contactPhone !== c.contactPhone;

  this.isTempContact = this.isContactModified;

  }

  // =====================================================
  // ✅ CASE 2: TYPED / TEMP CONTACT (NO IDs BUT VALUES)
  // =====================================================
  else if (!hasIds && hasValues) {

// ✅ If contact was JUST saved, do NOT revert to temp
  if (this._contactJustSaved) {
    this.isTempContact = false;
    this.isExistingContactSelected = true;
    this.isContactModified = false;
    this._contactJustSaved = false;// reset once
    this.refreshContactAutocomplete()
    this.http.onEnd() 
    return;
  }


    this.contactControl.setValue(ro.contactName || '', { emitEvent: false });
    this.emailControl.setValue(ro.contactEmail || '', { emitEvent: false });
    this.phoneControl.setValue(ro.contactPhone || '', { emitEvent: false });

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });

    this.isTempContact = true;
  }

  // =====================================================
  // ✅ CASE 3: TRULY FRESH (NO DATA AT ALL)
  // =====================================================
  else {

    this.contactControl.setValue('', { emitEvent: false });
    this.emailControl.setValue('', { emitEvent: false });
    this.phoneControl.setValue('', { emitEvent: false });

    this.requestCreateForm.patchValue({
      contactNameId: null,
      contactEmailId: null,
      contactPhoneId: null
    }, { emitEvent: false });
  }

  // =====================================================
  // ✅ DERIVE MODIFICATION STATE (DO NOT RESTORE IT)
  // =====================================================
  if (this.isExistingContactSelected && this._originalContact) {

    const name  = this._asText(this.contactControl.value, 'name');
    const email = this._asText(this.emailControl.value, 'email');
    const phone = this._asText(this.phoneControl.value, 'phone');

    this.isContactModified =
      name  !== this._originalContact.name ||
      email !== this._originalContact.email ||
      phone !== this._originalContact.phone;
  }

  // =========================
  // FINAL VALIDATION
  // =========================
  this.contactControl.updateValueAndValidity({ emitEvent: false });
  this.emailControl.updateValueAndValidity({ emitEvent: false });
  this.phoneControl.updateValueAndValidity({ emitEvent: false });
this.refreshContactAutocomplete();
  this.http.onEnd();
}



    public buildForm() {
        this.requestCreateForm = this.formBuilder.group({
            pickupSame: this.formBuilder.control(this.requestOrder.pickupSame ? this.requestOrder.pickupSame : "true", []),
            pickupAddressId: this.formBuilder.control(null, [Validators.required]),

            contactNameId: this.formBuilder.control(this.requestOrder.contactNameId || null),
            contactEmailId: this.formBuilder.control(this.requestOrder.contactEmailId || null),
            contactPhoneId: this.formBuilder.control(this.requestOrder.contactPhoneId || null),
            instructions: this.formBuilder.control(this.requestOrder.instructions ? this.requestOrder.instructions : '', [Validators.required]),
    
            // Pallet / parcels controls kept for compatibility but NOT required now
            palletSelected: this.formBuilder.control(this.requestOrder.palletSelected ? this.requestOrder.palletSelected : "false", []),
            // create pallet control but do not make it required (template removed)
            pallet: this.formBuilder.control({ value: this.requestOrder.pallet ? this.requestOrder.pallet : 'No Pallet', disabled: true }, []),
            // parcels kept but not required
            parcels: this.formBuilder.control(this.requestOrder.parcels ? this.requestOrder.parcels : 0, []),
    
            // ref/comment/fileUrl kept but ref is NOT required anymore (template removed for non-D2C)
            ref: this.formBuilder.control(this.requestOrder.ref ? this.requestOrder.ref : null, []),
            comment: this.formBuilder.control(this.requestOrder.comment ? this.requestOrder.comment : null, []),
            fileUrl: this.formBuilder.control(this.fileUrl ? this.fileUrl : [], []),
    
            // other flags / ids
            isFocOrder: false,
            isCoustumerManaged: false,
            soldToId: this.formBuilder.control(this.billingData.id ? this.billingData.id : null, []),
    
            /** added for D2C one time address */
            oneTimeFirstName: this.formBuilder.control(this.requestOrder.oneTimeFirstName ? this.requestOrder.oneTimeFirstName : null, [Validators.required]),
            oneTimeLastName: this.formBuilder.control(this.requestOrder.oneTimeLastName ? this.requestOrder.oneTimeLastName : null, [Validators.required]),
            oneTimeemail: this.formBuilder.control(this.requestOrder.oneTimeemail ? this.requestOrder.oneTimeemail : null, [Validators.email]),
            oneTimePhoneNumber: this.formBuilder.control(this.requestOrder.oneTimePhoneNumber ? this.requestOrder.oneTimePhoneNumber : null, [Validators.required]),
            oneTimeStreet: this.formBuilder.control(this.requestOrder.oneTimeStreet ? this.requestOrder.oneTimeStreet : null, [Validators.required]),
            oneTimeCity: this.formBuilder.control(this.requestOrder.oneTimeCity ? this.requestOrder.oneTimeCity : null, [Validators.required]),
            oneTimePostalCode: this.formBuilder.control(this.requestOrder.oneTimePostalCode ? this.requestOrder.oneTimePostalCode : null, [Validators.required]),
            oneTimeCountryCode: this.formBuilder.control(this.requestOrder.oneTimeCountryCode ? this.requestOrder.oneTimeCountryCode : null, [Validators.required]),
            companyName: this.formBuilder.control(
                this.requestOrder.companyName ? this.requestOrder.companyName : null,
                [Validators.required, Validators.maxLength(35)]
              ),
            poReference: this.formBuilder.control(
                this.requestOrder.poReference ? this.requestOrder.poReference : null,
                [Validators.required, Validators.maxLength(35)]
              ),
            additionalInfo: this.formBuilder.control(this.requestOrder.additionalInfo? this.requestOrder.additionalInfo:null,[Validators.required]),   
        });
    
        // preserve any existing behavior using these controls
        this.requestOrder.shippingCountry ? this.selectedCountry = this.requestOrder.shippingCountry : '';
        this.requestCreateForm.get('pickupSame').valueChanges.subscribe(data => {
            this.checkSameAddress(data);
        });
        this.requestCreateForm.get('palletSelected').valueChanges.subscribe(data => {
            this.checkPallet(data)
        });
    }
    

    public resetData() {
        this.requestOrder = {};
        this.tradeData = {};
        if (this.requestCreateForm) {
            this.requestCreateForm.controls['pickupSame'].setValue('true');
            this.requestCreateForm.controls['pickupAddressId'].setValue(null);
            this.requestCreateForm.controls['contactNameId'].setValue(null);
            this.requestCreateForm.controls['contactEmailId'].setValue(null);
            this.requestCreateForm.controls['contactPhoneId'].setValue(null);
            this.requestCreateForm.controls['instructions'].setValue('');
            this.requestCreateForm.controls['palletSelected'].setValue('false');
    
            // since pallet/parcels/ref are no longer required / visible, clear them safely
            if (this.requestCreateForm.controls['parcels']) {
                this.requestCreateForm.controls['parcels'].setValue(null);
            }
            if (this.requestCreateForm.controls['pallet']) {
                this.requestCreateForm.controls['pallet'].setValue('No Pallet');
            }
            if (this.requestCreateForm.controls['ref']) {
                this.requestCreateForm.controls['ref'].setValue(null);
            }
        }
    
        // UI state
        this.selectedAddress = null;
        this.selectedContactName = null;
        this.selectedContactEmail = null;
        this.selectedContactPhone = null;
        this.selectedParcel = null;
        this.addressList = [];
        this.contactList = [];
        this.enableButtons = false;
        this.isShippingCountry = true;
        this.selectedCountry = ''
    }
    

    public setDefaultData() {
        if (Object.keys(this.requestOrder).length > 0) {
            if (this.requestOrder.contactNameId) {
                this.selectedContactName = this.requestOrder.contactNameId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactName == this.requestOrder.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                }
            }
            if (this.requestOrder.contactEmailId) {
                this.selectedContactEmail = this.requestOrder.contactEmailId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactEmail == this.requestOrder.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                }
            }
            if (this.requestOrder.contactPhoneId) {
                this.selectedContactPhone = this.requestOrder.contactPhoneId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactPhone == this.requestOrder.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }
        } else if (this.tradeData) {
            if (this.tradeData.contactNameId) {
                this.selectedContactName = this.tradeData.contactNameId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactName == this.tradeData.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactEmailId) {
                this.selectedContactEmail = this.tradeData.contactEmailId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactEmail == this.tradeData.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactPhoneId) {
                this.selectedContactPhone = this.tradeData.contactPhoneId;
            } else {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactPhone == this.tradeData.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }
        }

      const draft = this.commonService.getData();
      let instr = '';
      if(draft && draft.requestOrder && draft.requestOrder.instructions){
        instr = draft.requestOrder.instructions
      }else if (this.requestOrder && this.requestOrder.instructions){
        instr = this.requestOrder.instructions
      }
      this.requestCreateForm.controls['instructions'].setValue(instr, { emitEvent: false });

        if (Object.keys(this.requestOrder).length > 0) {
            if (this.requestOrder.palletSelected == false || this.requestOrder.palletSelected == 'false') {
                this.requestCreateForm.controls['palletSelected'].setValue("false");
                this.checkPallet('false');
            } else if (this.requestOrder.palletSelected == true || this.requestOrder.palletSelected == 'true') {
                this.requestCreateForm.controls['palletSelected'].setValue("true");
                this.checkPallet('true');
            }
            if (this.requestOrder.isCoustumerManaged == false || this.requestOrder.isCoustumerManaged == 'false') {
                this.requestCreateForm.controls['isCoustumerManaged'].setValue("false");
                //  this.CoustumerManaged('false');
            } else if (this.requestOrder.isCoustumerManaged == true || this.requestOrder.isCoustumerManaged == 'true') {
                this.requestCreateForm.controls['isCoustumerManaged'].setValue("true");
                // this.CoustumerManaged('true');
            }
            if (this.requestOrder.pickupSame == true || this.requestOrder.pickupSame == 'true') {
                this.requestCreateForm.controls['pickupSame'].setValue("true");
                this.checkSameAddress('true');
            } else if (this.requestOrder.pickupSame == false || this.requestOrder.pickupSame == 'false') {
                this.requestCreateForm.controls['pickupSame'].setValue("false");
                this.checkSameAddress('false');
            }
        } else {
            if (
                this.requestCreateForm &&
                this.requestCreateForm.get('pickupSame') &&
                this.requestCreateForm.get('pickupSame').value === 'true'
              ) {
                this.setDefaultAddress();
              }
              
        }
        
        if (this.requestOrder.ref) {
            this.requestCreateForm.controls['ref'].setValue(this.requestOrder.ref);
        }
        this.http.onEnd();
    }

    public isInArray(value, array) {
        return array.indexOf(value) > -1;
    }
get isNextDisabled(): boolean {
  // old logic: form must be valid
  if (!this.requestCreateForm || this.requestCreateForm.invalid) {
    return true;
  }

  // contact fields are OUTSIDE the form → add them explicitly
  if (
    this.contactControl.invalid ||
    this.emailControl.invalid ||
    this.phoneControl.invalid
  ) {
    return true;
  }

  // also guard against empty strings
  const name  = this._asText(this.contactControl.value, 'name');
  const email = this._asText(this.emailControl.value, 'email');
  const phone = this._asText(this.phoneControl.value, 'phone');

  return !name || !email || !phone;
}

    
public setDefaultAddress(): boolean {
  // If user has chosen "No" don't auto-populate
  if (
    this.requestCreateForm &&
    this.requestCreateForm.get('pickupSame') &&
    this.requestCreateForm.get('pickupSame').value === 'false'
  ) {
    return false;
  }

  if (this.addressList && this.billingData) {

    // ensure soldToId is synced
    if (this.billingData.id) {
                this.requestCreateForm.controls['soldToId'].setValue(this.billingData.id);
            }

    const match = this.addressList.find(a => a.address === this.billingData.invoiceAddress);

    if (match) {
      this.selectedAddress = match.id;
      this.selectedCountry = match.country || '';

      if (match.country === '') {
        this.isShippingCountry = false;
      }

      // 1) store id in the form model
      this.requestCreateForm.get('pickupAddressId').setValue(match.id, { emitEvent: false });

      // 2) put the object into the control for display (so displayWith can render text)
      const pickupCtrl = this.requestCreateForm.get('pickupAddressId') as FormControl;
      pickupCtrl.setValue(match, { emitEvent: false }); // IMPORTANT for UI text

      // 3) set pickupSame to 'true' if needed
      if (this.requestCreateForm.get('pickupSame').value !== 'true') {
        this.requestCreateForm.get('pickupSame').setValue('true', { emitEvent: false });
      }

      // 4) disable the control (since it's "same as above")
      this.requestCreateForm.get('pickupAddressId').disable({ emitEvent: false });

      return true;
    } else {
      // No match → force user to pick another address
      this.requestCreateForm.get('pickupSame').setValue('false', { emitEvent: false });
    }
  }

  return false;
}


    public checkPallet(check) {
        let control = this.requestCreateForm.get('pallet');
        let control1 = this.requestCreateForm.get('parcels');
        let control2 = this.requestCreateForm.get('isCoustumerManaged');
        var isCoustumerManaged = control2.value;
        //     if(!isCoustumerManaged){
        if (check == "true") {
            if (this.requestOrder.pallet != '0' && this.requestOrder.pallet != "No Pallet") {
                this.requestCreateForm.controls['pallet'].setValue(this.requestOrder.pallet);
            } else {
                this.requestCreateForm.controls['pallet'].setValue(null);
            }
            this.requestCreateForm.controls['parcels'].setValue('No Parcel');
            control.enable()
            control1.disable();
        } else {
            this.requestCreateForm.controls['pallet'].setValue('No Pallet');
            if (this.requestOrder.parcels != '') {
                this.selectedParcel = this.requestOrder.parcels;
            } else {
                this.requestCreateForm.controls['parcels'].setValue(null);
            }
            control.disable();
            control1.enable();
        }
        //  }

    }

    public onlyNumber(evt) {
        if (/^[0-9]+$/i.test(String.fromCharCode(evt.charCode)) == false) {
            evt.returnValue = false;
            return false;
        }
    }
    
    
public checkSameAddress(check: string) {
  const ctrl = this.requestCreateForm.get('pickupAddressId') as FormControl;

  if (check === 'true') {
    const res = this.setDefaultAddress();
    if (res) {
      ctrl.disable({ emitEvent: false });
    }
  } else {

    ctrl.enable({ emitEvent: false });

    ctrl.setValue('', { emitEvent: true });

    ctrl.markAsTouched();
    ctrl.markAsDirty();

    this.selectedAddress = null;

    this.requestCreateForm.patchValue(
      { pickupAddressId: null },
      { emitEvent: false }
    );

  }
}



   public setFormDetails() {

  // ---------- ADDRESS LOGIC MUST ALWAYS RUN ----------
  if (this.addressList && this.requestFormData.requestOrder.pickupAddressId) {
    const addr = this.addressList.find(a =>
      String(a.id) === String(this.requestFormData.requestOrder.pickupAddressId)
    );

    if (addr) {
      this.requestFormData.requestOrder.pickupAddress = addr.address;
      this.requestFormData.requestOrder.tradePartnerAddress = {
        ...addr,
        id: addr.manual === true
          ? this.requestFormData.requestOrder.soldToId
          : addr.id
      };

      if (addr.manual === true) {
        this.requestFormData.requestOrder.pickupAddressId =
          this.requestFormData.requestOrder.soldToId;
      }
    }
  }

  // ---------- CONTACT LOGIC (skip ONLY when temp) ----------
  if (
    this.contactList &&
    this.requestFormData &&
    this.requestFormData.requestOrder &&
    !this.requestFormData.requestOrder.isTempContact
  ) {
    for (let i in this.contactList) {
      if (this.contactList[i].id == this.requestFormData.requestOrder.contactNameId) {
        this.requestFormData.requestOrder.contactName =
          this.contactList[i].contactName;
      }
      if (this.contactList[i].id == this.requestFormData.requestOrder.contactEmailId) {
        this.requestFormData.requestOrder.contactEmail =
          this.contactList[i].contactEmail;
      }
      if (this.contactList[i].id == this.requestFormData.requestOrder.contactPhoneId) {
        this.requestFormData.requestOrder.contactPhone =
          this.contactList[i].contactPhone;
      }
    }
  }

  return true;
}
// private _asText(
//   val: any,
//   kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
// ): string {
//   if (val == null) return '';

//   if (typeof val === 'string') return val.trim();

//   if (typeof val === 'object') {
//     if (kind === 'name')    return (val.contactName || '').trim();
//     if (kind === 'email')   return (val.contactEmail || '').trim();
//     if (kind === 'phone')   return (val.contactPhone || '').trim();
//     if (kind === 'address') return (val.address || '').trim();

//     // ✅ sold-to / trade partner
//     if (kind === 'soldTo') {
//       return (
//         val.soldTo ||
//         val.tradePartnerId ||
//         val.id ||
//         ''
//       ).toString().trim();
//     }
//   }

//   return String(val || '').trim();
// }

getHighlightedParts(
  text: string,
  search: any,
  kind: 'name' | 'email' | 'phone' | 'address' | 'soldTo'
): { value: string; match: boolean }[] {

  if (!text) {
    return [{ value: '', match: false }];
  }

  const term = this._asText(search, kind);

  if (!term) {
    return [{ value: text, match: false }];
  }

  const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(escaped, 'ig');

  const parts: { value: string; match: boolean }[] = [];
  let lastIndex = 0;
  let m: RegExpExecArray | null;

  while ((m = regex.exec(text)) !== null) {
    const start = m.index;
    const end = start + m[0].length;

    if (start > lastIndex) {
      parts.push({
        value: text.substring(lastIndex, start),
        match: false
      });
    }

    parts.push({
      value: m[0],
      match: true
    });

    lastIndex = end;
  }

  if (lastIndex < text.length) {
    parts.push({
      value: text.substring(lastIndex),
      match: false
    });
  }

  return parts;
}

    public goToNextPage() {
      const name = this._asText(this.contactControl.value, 'name');
      const email = this._asText(this.emailControl.value, 'email');
      const phone = this._asText(this.phoneControl.value, 'phone');

if (!name || !email || !phone) {
  this.dialogRef = this.dialog.open(dialogComponent);
  this.dialogRef.componentInstance.msg =
    'Contact Name, Email and Phone are required.';
  return;
}


        // ensure soldToId is always in sync
        if (
          this.requestCreateForm &&
          this.requestCreateForm.get('soldToId') &&
          this.tradePartnerId
        ) {
          this.requestCreateForm
            .get('soldToId')
            .setValue(this.tradePartnerId, false);
        }
      

const rawVal = this.requestCreateForm.get('pickupAddressId') ?this.requestCreateForm.get('pickupAddressId').value : null;
  if (rawVal && typeof rawVal === 'object') {
    this.requestCreateForm.patchValue({ pickupAddressId: rawVal.id }, { emitEvent: false });
  }
          // read form values
        this.requestFormData['requestOrder'] =
          this.requestCreateForm.getRawValue();
      
 
        this.requestFormData.requestOrder.contactName = name;
        this.requestFormData.requestOrder.contactEmail = email;
        this.requestFormData.requestOrder.contactPhone = phone;

        // Explicitly mark as temporary
        console.log(this.isExistingContactSelected+" --"+this.isContactModified)
        this.requestFormData.requestOrder.isTempContact = !this.isExistingContactSelected || this.isContactModified;
       
        // D2C handling (unchanged)
        this.responseSaveForD2cUser();
      
        // trade id / created by
        if (this.isAdmin) {
          this.requestFormData.tradeId =
            this.tradePartnerId.replace(/^0+/, '');
        }
        this.requestFormData.createdBy = this.createdBy;
        this.responsibleError = null;
      
        // 🔑 FINAL ADDRESS RESOLUTION
        if (this.setFormDetails()) {
      
          // if user explicitly selected a different delivery address
          if (this.requestCreateForm.get('pickupSame').value === 'false') {
            this.requestFormData.requestOrder.pickupAddressId =
              this.requestCreateForm.get('pickupAddressId').value;
          }
      
          console.log(this.requestFormData);
      
          this.commonService.setData(this.requestFormData);
      
          if (!isNaN(this.id)) {
            this.router.navigateByUrl('/app/focrequests/return/' + this.id);
          } else {
            this.router.navigateByUrl('/app/focrequests/return');
          }
        }

     

    }
      

    public save() {
        this.requestFormData['requestOrder'] = this.requestCreateForm.getRawValue();
        if (this.isAdmin || this.isOTD || this.isEndConsumner || this.isFocOrder) {
            this.requestFormData.tradeId = this.tradePartnerId.replace(/^0+/, '');
        }
        if (this.setFormDetails()) {
            this.requestFormData.email = this.userData.email;
            this.requestFormData.userId = this.userData.userId;
            this.requestFormData.tradePartnerId = this.userData.tradePartnerId;
            this.http.postRequest(this.requestFormData, 'returnOrder/v1/saveReturnOrder').subscribe(
                res => {
                    this.saveResponse(res);
                },
                err => {
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Save Failed';

                    }
                    this.http.onEnd();
                }
            );
        }
    }

    public saveResponse(res) {
        this.http.onEnd();
        if (res.status == 'Success') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Request Saved As Draft';
            this.commonService.setData(null);
            this.router.navigateByUrl('/app/focdashboard');
        }
        if (res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
    }

    uploadFile(data: any) {
        console.log(data);
        console.log(data.target.files[0]);
        let i = 0;
        let input = new FormData();
        while (i < data.target.files.length) {

            //input = data.target.files[i];
            input.append("files", data.target.files[i]);
            console.log('file found')
            i++;
        }
        this.requestFormData.returnUploadFiles = input;
        console.log(this.requestFormData.returnUploadFiles);

    }

    public fileupload() {
        let formData = new FormData();
        for (let i in this.uploader.queue) {
            this.http.showLoader();
            this.isFileUploaded = true;
            formData.append('file', this.uploader.queue[i]._file);
            let headers = new Headers({ 'apiKey': 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y', 'access-token': this.sessionHandler.getItem('token') });
            this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
            this.Http
                .post(this.URL, formData, { headers: headers })
                .toPromise()
                .then(res => this.setUploadData(res.json()))
                .catch(error => this.handleError(error))
        }
    }
    public handleError(e) {
        //this.showError(e, false);
        console.log('error found -- file upload....' + e);
        this.fileUploadResponse = e;
        this.isFileUploadError = true;
        this.http.onEnd();
    }

    public setUploadData(res) {

        this.uploader = new FileUploader({ url: this.URL, disableMultipart: true });
        if (res.responseCode == 200) {
            this.isFileUploadError = false;
            this.fileUrl.push({
                "fileName": res.documentName ? res.documentName : '',
                "fileUrl": res.fileUrl
            });
            this.commonService.setWrtImageData(this.fileUrl);
            // this.fileUrl.push(res.fileUrl);
            this.fileUploadResponse = res.message;
        } else if (res.responseCode == 400) {
            this.isFileUploadError = true;
            this.fileUploadResponse = res.message;
        }
        this.http.onEnd();
    }
    CoustumerManaged(check) {
        let control = this.requestCreateForm.get('pallet');
        let control1 = this.requestCreateForm.get('parcels');
        let controlselected = this.requestCreateForm.get('palletSelected');


        if (check) {
            this.requestCreateForm.controls['parcels'].setValue('No Parcel');
            this.requestCreateForm.controls['pallet'].setValue('No Pallet');
            control.disable();
            control1.disable();
            controlselected.disable();
        } else {
            this.requestCreateForm.get('palletSelected').valueChanges.subscribe(data => {
                this.checkPallet(data)
            });
            controlselected.enable();

        }
    }

    public onChange(data) {                                     //function to select country on address change
        try {
            this.isShippingCountry = true;
            if (data && this.addressList)                                           //check address id and current selected id(data)
                this.addressList.forEach(ele => {
                    if (Number(data) === Number(ele.id)) {
                        ele.country.length > 0 ? this.countryFromID = ele.country : this.countryFromID = '';
                    }
                    else this.selectedCountry = '';
                });

          
        } catch (error) {
            console.log('exception occured', error);
        }

    }

 
    public saveNewAddress() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner || this.isFocOrder) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewAddressComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
    }

    public saveNewContact() {
        let tradeId;
        if (this.isAdmin || this.isOTD || this.isEndConsumner || this.isFocOrder) {
            if (this.requestFormData.tradeId && this.requestFormData.tradeId != null && this.requestFormData.tradeId != '' && this.requestFormData.tradeId == this.tradePartnerId) {
                tradeId = this.requestFormData.tradeId;
            } else {
                tradeId = this.tradePartnerId;
            }
        } else if (this.userData && this.userData.tradePartnerId) {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewContactComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
        this.dialogRef.componentInstance.fromFoc = true;
        //this.getAddressList('saved');
    }

    
get canSaveContact(): boolean {
  return (
    this.isContactFormValid &&
    (
      this.isTempContact ||                     // new contact
      (this.isExistingContactSelected && this.isContactModified) // save-as-new
    )
  );
}

get canUpdateContact(): boolean {
  return (
    this.isContactFormValid &&
    this.isExistingContactSelected &&
    this.isContactModified
  );
}


saveContact() {
  if (!this.isContactFormValid || this.saving) {
    return;
  }

  this.saving = true;

  const payload = {
    tradePartnerId: this.tradePartnerId,
    contactName: this._asText(this.contactControl.value, 'name'),
    contactEmail: this._asText(this.emailControl.value, 'email'),
    contactPhone: this._asText(this.phoneControl.value, 'phone')
  };

  this.http.postRequest(payload, 'userOperationsApi/v1/addContact')
    .subscribe(
      (res: any) => {
        this.saving = false;
       
        // ✅ Ensure backend really returned an ID
        if (res && res.statusCode === 200 && res.id) {

          const newId = res.id;

          this._originalContact = {
            name: this._asText(this.contactControl.value, 'name'),
            email: this._asText(this.emailControl.value, 'email'),
            phone: this._asText(this.phoneControl.value, 'phone')
          };

          // ✅ STORE IDs → this is the KEY FIX
          this.requestCreateForm.patchValue({
            contactNameId: newId,
            contactEmailId: newId,
            contactPhoneId: newId
          }, { emitEvent: false });

          // ✅ Update UI state
          this._contactJustSaved = true;
          this.isTempContact = false;
          this.isExistingContactSelected = true;
          this.isContactModified = false;

          // ✅ Refresh contact list
          this.commonService.contactChange.next();

          // ✅ Success dialog
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg =
            this.translate.instant('contact_added_success');
        } else {
          // fallback (should not normally happen)
          this.dialogRef = this.dialog.open(dialogComponent);
          this.dialogRef.componentInstance.msg =
            'Contact saved, but could not retrieve contact ID.';
        }
      },
      (err) => {
        this.saving = false;

        let msg = 'Unable to save contact';

        if (err && err.status === 400) {
          if (err.error && err.error.message) {
            msg = err.error.message;
          } else if (
            err.error &&
            err.error.errors &&
            err.error.errors.length
          ) {
            msg = err.error.errors[0].message;
          }
        }

        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = msg;

        console.error('saveContact error', err);
      }
    );
}

  
updateContact() {
  if (!this.isContactFormValid || this.saving) {
    return;
  }

  const contactId = this.requestCreateForm.get('contactNameId').value;
  if (!contactId) {
    return;
  }

  this.saving = true;
  

  const payload = {
    contactId: contactId,
    contactName: this._asText(this.contactControl.value, 'name'),
    contactEmail: this._asText(this.emailControl.value, 'email'),
    contactPhone: this._asText(this.phoneControl.value, 'phone')
  };

  this.http.postRequest(payload, 'userOperationsApi/v1/updateContact')
    .subscribe(
      (res) => {
        this.saving = false;

        // ✅ contact remains EXISTING
        
        this._originalContact = {
          name: this._asText(this.contactControl.value, 'name'),
          email: this._asText(this.emailControl.value, 'email'),
          phone: this._asText(this.phoneControl.value, 'phone')
        };

        this.isTempContact = false;
        this.isExistingContactSelected = true;
        this.isContactModified = false;

        this.commonService.contactChange.next();

        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = 'Contact Updated Successfully';
      },
      (err) => {
        this.saving = false;

        let msg = 'Unable to update contact';

        if (err && err.status === 400) {
          if (err.error && err.error.message) {
            msg = err.error.message;
          } else if (
            err.error &&
            err.error.errors &&
            err.error.errors.length
          ) {
            msg = err.error.errors[0].message;
          }
        }

        this.dialogRef = this.dialog.open(dialogComponent);
        this.dialogRef.componentInstance.msg = msg;

        console.error('updateContact error', err);
      }
    );
}


    updateFormValidationForD2C(isD2CUser){/**added for  D2c one time address */
    if(isD2CUser){
            this.requestCreateForm.get('pickupSame').clearValidators();
            this.requestCreateForm.get('pickupSame').updateValueAndValidity(); 
            
            this.requestCreateForm.get('pickupAddressId').clearValidators();
            this.requestCreateForm.get('pickupAddressId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactNameId').clearValidators();
            this.requestCreateForm.get('contactNameId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactEmailId').clearValidators();
            this.requestCreateForm.get('contactEmailId').updateValueAndValidity(); 

            this.requestCreateForm.get('contactPhoneId').clearValidators();
            this.requestCreateForm.get('contactPhoneId').updateValueAndValidity(); 

            this.requestCreateForm.get('instructions').clearValidators();
            this.requestCreateForm.get('instructions').updateValueAndValidity(); 

            this.requestCreateForm.get('palletSelected').clearValidators();
            this.requestCreateForm.get('palletSelected').updateValueAndValidity(); 

            this.requestCreateForm.get('pallet').clearValidators();
            this.requestCreateForm.get('pallet').updateValueAndValidity(); 

            this.requestCreateForm.get('parcels').clearValidators();
            this.requestCreateForm.get('parcels').updateValueAndValidity(); 

            this.requestCreateForm.get('ref').clearValidators();
            this.requestCreateForm.get('ref').updateValueAndValidity(); 

            this.requestCreateForm.get('comment').clearValidators();
            this.requestCreateForm.get('comment').updateValueAndValidity(); 

            this.requestCreateForm.get('fileUrl').clearValidators();
            this.requestCreateForm.get('fileUrl').updateValueAndValidity(); 

            // this.requestCreateForm.get('shippingCountry').clearValidators();
            // this.requestCreateForm.get('shippingCountry').updateValueAndValidity(); 

            // this.requestCreateForm.get('soldToId').clearValidators();
            // this.requestCreateForm.get('soldToId').updateValueAndValidity(); 
    }else{
            this.requestCreateForm.get('oneTimeFirstName').clearValidators();
            this.requestCreateForm.get('oneTimeFirstName').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeLastName').clearValidators();
            this.requestCreateForm.get('oneTimeLastName').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeemail').clearValidators();
            this.requestCreateForm.get('oneTimeemail').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimePhoneNumber').clearValidators();
            this.requestCreateForm.get('oneTimePhoneNumber').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeStreet').clearValidators();
            this.requestCreateForm.get('oneTimeStreet').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeCity').clearValidators();
            this.requestCreateForm.get('oneTimeCity').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimePostalCode').clearValidators();
            this.requestCreateForm.get('oneTimePostalCode').updateValueAndValidity(); 

            this.requestCreateForm.get('oneTimeCountryCode').clearValidators();
            this.requestCreateForm.get('oneTimeCountryCode').updateValueAndValidity(); 
    }

    }

    responseSaveForD2cUser(){
        this.requestFormData['isD2CUser']=this.isD2CUser;
        if(this.isD2CUser){
            this.requestFormData['requestOrder']['tpDetails']={};
            this.requestFormData['requestOrder']['tpDetails']['name1']=  this.requestFormData['requestOrder']['oneTimeFirstName'];
            this.requestFormData['requestOrder']['tpDetails']['name2']= this.requestFormData['requestOrder']['oneTimeLastName'];
            this.requestFormData['requestOrder']['tpDetails']['contactEmail']= this.requestFormData['requestOrder']['oneTimeemail'];
            this.requestFormData['requestOrder']['tpDetails']['contactPhone']= this.requestFormData['requestOrder']['oneTimePhoneNumber'];
            this.requestFormData['requestOrder']['tpDetails']['street']= this.requestFormData['requestOrder']['oneTimeStreet'];
            this.requestFormData['requestOrder']['tpDetails']['city']= this.requestFormData['requestOrder']['oneTimeCity'];
            this.requestFormData['requestOrder']['tpDetails']['zipCode']= this.requestFormData['requestOrder']['oneTimePostalCode'];
            this.requestFormData['requestOrder']['tpDetails']['country']= this.requestFormData['requestOrder']['oneTimeCountryCode'];
            this.requestFormData['requestOrder']['tpDetails']['addressId'] =
            this.requestFormData['requestOrder'].pickupAddressId;
                  }
        delete this.requestFormData['requestOrder']['oneTimeFirstName'];
        delete this.requestFormData['requestOrder']['oneTimeLastName'];
        delete this.requestFormData['requestOrder']['oneTimeemail'];
        delete this.requestFormData['requestOrder']['oneTimePhoneNumber'];
        delete this.requestFormData['requestOrder']['oneTimeStreet'];
        delete this.requestFormData['requestOrder']['oneTimeCity'];
        delete this.requestFormData['requestOrder']['oneTimePostalCode'];
        delete this.requestFormData['requestOrder']['oneTimeCountryCode'];
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt-foc/foc-create/foc-request_add.component.ts